import { useCompanyStore } from '../store/company/companyStore'

const TRIAL_DURATION_DAYS = 14

export const useTrialStatus = () => {
  const company = useCompanyStore((state) => state.company)
  const user = useCompanyStore((state) => state.user)

  const isFreePlan = !company.plan || company.plan === 'free'
  const isDemo = user?.isDemo ?? false

  let createdAtDate: Date | undefined = undefined
  if(company.createdAt) {
    createdAtDate = new Date(company.createdAt)
  } else {
    // use 29th March 2026
    createdAtDate = new Date('2026-03-29')
  }

  if (!isFreePlan || isDemo || !createdAtDate) {
    return { isTrialActive: false, isTrialExpired: false, daysRemaining: 0 }
  }

  const now = new Date()
  const diffMs = now.getTime() - createdAtDate.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  const daysRemaining = Math.max(0, TRIAL_DURATION_DAYS - diffDays)

  return {
    isTrialActive: daysRemaining > 0,
    isTrialExpired: daysRemaining === 0,
    daysRemaining
  }
}
